import { SVGProps } from "react";
import iconURL from "../../../assets/svg/icons.svg";

type IconID =
  | "external-link"
  | "caret-down"
  | "caret-right"
  | "chevron-right"
  | "chevron-left"
  | "chevron-up"
  | "chevron-down";

/*
 *
 * 🚧 UNDER CONSTRUCTION 🚧
 *
 */

export interface IconProps {
  /**
   * The spritesheet ID defined in the Icons spritesheet.
   */
  id: IconID;

  /**
   * The desired width/height of the icon. Accepts any valid CSS unit.
   */
  size?: number | string;

  /**
   * The stroke color of the icon.
   */
  color?: string;
}

/**
 * An icon component that displays SVG icons from a sprite sheet or inline.
 *
 * API:
 *  - {@link IconProps}
 */
export function Icon(props: IconProps) {
  let iconStyle = {
    height: props.size || undefined,
    width: props.size || undefined,
    color: props.color || undefined,
  };

  if (props.id === "chevron-right") {
    return <Chevron direction="right" {...iconStyle} />;
  }

  if (props.id === "chevron-left") {
    return <Chevron direction="left" {...iconStyle} />;
  }

  if (props.id === "chevron-up") {
    return <Chevron direction="up" {...iconStyle} />;
  }

  if (props.id === "chevron-down") {
    return <Chevron direction="down" {...iconStyle} />;
  }

  return (
    <svg style={iconStyle} {...props}>
      <use href={`${iconURL}#${props.id}`} />
    </svg>
  );
}

function Chevron({
  direction,
  ...props
}: {
  direction: "right" | "left" | "up" | "down";
} & SVGProps<SVGSVGElement>) {
  const rotateMap = {
    right: 0,
    down: 90,
    left: 180,
    up: 270,
  };

  return (
    <svg
      viewBox="0 0 16 16"
      style={{
        transform: `rotate(${rotateMap[direction]}deg)`,
      }}
      {...props}
    >
      {/* NOTE: this is the path for the "right" direction */}
      <path
        fill="currentColor"
        d="M5.74 3.2a.75.75 0 0 0-.04 1.06L9.227 8L5.7 11.74a.75.75 0 1 0 1.1 1.02l4-4.25a.75.75 0 0 0 0-1.02l-4-4.25a.75.75 0 0 0-1.06-.04"
      />
    </svg>
  );
}
